import { render, staticRenderFns } from "./SwitchAccountModal.vue?vue&type=template&id=406b6b3a&scoped=true&ref=switchAccountModal"
import script from "./SwitchAccountModal.vue?vue&type=script&lang=ts"
export * from "./SwitchAccountModal.vue?vue&type=script&lang=ts"
import style0 from "./SwitchAccountModal.vue?vue&type=style&index=0&id=406b6b3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b6b3a",
  null
  
)

export default component.exports